import tenantUtils from '@utils';
import { getTimeDateString } from '../../../utility/date';
import { t } from 'i18next';

const getLeadsStaffFilters = (users) => [
  {
    type: 'unitSelect',
    label: 'Search By',
    key: 'search',
    subList: [
      { label: t('Listing ID'), key: 'listing_id', queryParamKey: 'q[interests_listing_id_eq]' },
      { label: t('Lead ID'), key: 'lead_id', queryParamKey: 'q[lead_client_id_eq]' },
      { label: t('Lead Name'), key: 'lead_name', queryParamKey: 'q[name_start]' },
    ],
  },
  {
    label: 'Lead Received',
    key: 'lead_received',
    queryParamKey: ['q[created_at_gteq]', 'q[created_at_lteq]'],
    placeholder: 'Select Date Range',
    type: 'dateRange',
    getOptionLabel: (value) => {
      return value
        .split(',')
        .map((e) => getTimeDateString(e, false, true, false, false))
        .join(' - ');
    },
  },
  {
    label: 'Last Interaction',
    key: 'last_interaction',
    queryParamKey: ['q[updated_at_gteq]', 'q[updated_at_lteq]'],
    placeholder: 'Select Date Range',
    type: 'dateRange',

    getOptionLabel: (value) => {
      return value
        .split(',')
        .map((e) => getTimeDateString(e, false, true, false, false))
        .join(' - ');
    },
  },
  ...(users?.length > 1
    ? [
        {
          key: 'user_id',
          queryParamKey: 'q[user_id_eq]',
          label: 'Users',
          labelProps: { muted: true },
          placeholder: 'Select Users',
          type: 'select',
          list: users,
          showTag: true,
          singleValue: true,
          getOptionLabel: (e) => tenantUtils.getLocalisedString(e, 'name'),
          getOptionValue: (op) => op.id.toString(),
        },
      ]
    : []),

];
export default getLeadsStaffFilters;

